var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationIconDialogueEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9F5B6863-E5DA-4FAE-91F9-1ADBCA34F699") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-Feed-Left",
    transform: "translate(-698.000000, -3478.000000)",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions",
    transform: "translate(600.000000, 3476.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-comment",
    transform: "translate(96.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,20.8559384 C22,21.9630801 21.2795511,22.3218556 20.4015962,21.665335 L15.5,18 L4.00001277,18 C2.89543622,18 2,17.1054862 2,15.9978711 L2,4.00212885 C2,2.89638362 2.89821238,2 4.00001277,2 L19.9999872,2 C21.1045638,2 22,2.89451376 22,4.00212885 L22,20.8559384 Z M20,4.00212885 L4.00001277,4 L4,15.9978711 L16.1650895,16 L20.0189792,18.8818769 L20,4.00212885 Z M12,11.5 C11.1715729,11.5 10.5,10.8284271 10.5,10 C10.5,9.17157288 11.1715729,8.5 12,8.5 C12.8284271,8.5 13.5,9.17157288 13.5,10 C13.5,10.8284271 12.8284271,11.5 12,11.5 Z M8,11.5 C7.17157288,11.5 6.5,10.8284271 6.5,10 C6.5,9.17157288 7.17157288,8.5 8,8.5 C8.82842712,8.5 9.5,9.17157288 9.5,10 C9.5,10.8284271 8.82842712,11.5 8,11.5 Z M16,11.5 C15.1715729,11.5 14.5,10.8284271 14.5,10 C14.5,9.17157288 15.1715729,8.5 16,8.5 C16.8284271,8.5 17.5,9.17157288 17.5,10 C17.5,10.8284271 16.8284271,11.5 16,11.5 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationIconDialogueEmpty);
export default __webpack_public_path__ + "static/media/application_icon_dialogue_empty.9b2cd998a8b5ba74c11aba7cc2799a48.svg";
export { ForwardRef as ReactComponent };